module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.chat.lastUpdated >= _vm.after) ? _c('router-link', {
    class: {
      'chat-item': true, 'multiple': (_vm.members.length > 2), 'notify': (_vm.unreads['.value'] > 0)
    },
    attrs: {
      "to": '/chats/' + _vm.id
    }
  }, [_c('div', {
    on: {
      "click": _vm.read
    }
  }, [(_vm.members.length > 2) ? _c('div', {
    staticClass: "image-holder"
  }, _vm._l((_vm.members), function(member, id) {
    return (id < 4) ? _c('profile-picture', {
      key: member['.key'],
      attrs: {
        "member": member['.key'],
        "index": id,
        "total": _vm.members.length
      }
    }) : _vm._e()
  })) : _c('div', _vm._l((_vm.members), function(member, id) {
    return (member['.key'] !== _vm.$root.user.uid) ? _c('profile-picture', {
      key: member['.key'],
      attrs: {
        "member": member['.key']
      }
    }) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [(_vm.members.length > 2) ? _c('h5', _vm._l((_vm.members), function(member, id) {
    return _c('first-name-list', {
      key: member['.key'],
      attrs: {
        "member": member['.key'],
        "deli": ',',
        "showDeli": (id + 1 < _vm.members.length)
      }
    })
  })) : _c('h5', _vm._l((_vm.members), function(member, id) {
    return (member['.key'] !== _vm.$root.user.uid) ? _c('full-name-list', {
      key: member['.key'],
      attrs: {
        "member": member['.key']
      }
    }) : _vm._e()
  })), _vm._v(" "), (_vm.unreads['.value'] > 0) ? _c('span', {
    staticClass: "notification"
  }, [_vm._v(_vm._s(_vm.unreads['.value']))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v(_vm._s(_vm.dateFormat(_vm.chat.lastUpdated, 'h:MMtt')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.chat.lastMessage))])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48fb2d4e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/list/Item.vue
// module id = 709
// module chunks = 1